// extracted by mini-css-extract-plugin
module.exports = {"big":"titleComponent_big__2NbUz","medium":"titleComponent_medium__1CE9u","small":"titleComponent_small__17k9j","centered":"titleComponent_centered__2TAVV"};
    if(module.hot) {
      // 1790670294662
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  